import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
export const sendGiveawaySummariesEndpoint = {
    [giveawayEndpointIds.SEND_GIVEAWAY_SUMMARIES]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
